import { localeSpecificGroup } from '../../../utils/override';
import {
  staticText,
  brandSpecificStaticText,
} from '../../../utils/translations/staticText';
import { money101Translation } from './money101';
import { moneyHeroTranslation } from './moneyhero';
import { moneyMaxTranslation } from './moneymax';

export const baseTranslations = {
  loan_details: {
    _: 'Loan details',
    zh: '產品資訊',
  },
  card_details: {
    _: 'Card Details',
    zh: '信用卡詳情',
  },
  offers: {
    _: 'Offers',
    zh: '優惠',
  },
  card_details_ti_ci: {
    _: 'Card Details',
    zh: '產品詳情',
  },
  stk_bka_product_details: {
    _: 'Product Details',
    zh: '產品資訊',
  },
  sta_bka_bank_gift: {
    _: `Provider Gift - On Top of SingSaver's`,
  },
  bank_gift: {
    _: `Bank Gift - On Top of SingSaver's`,
  },
  apply_now: {
    _: 'Apply Now',
    zh: '立即申請',
  },
  apply_through: {
    _: 'Apply through SingSaver and choose from :count premium rewards',
  },
  apply_through_ci: {
    _: 'Apply through SingSaver and choose from <b>:count premium rewards:</b>',
  },
  apply_through_stk_bka: {
    _: 'Apply through SingSaver and choose from :count premium rewards (Actual Gift eligibility depends on the deposit amount provided in the terms and conditions)',
    zh: '經MoneyHero申請，精選獎賞任你揀！獎賞選擇 :count (實際獎賞資格須視乎條款及細則所列的存款金額而定)',
  },
  purchase_through: {
    _: 'Purchase through SingSaver and choose from :count premium rewards',
  },
  buy_now: {
    _: 'Buy Now',
    zh: '立即購買',
  },
  express_checkout: {
    _: 'Express Checkout',
    zh: '立即投保',
  },
  // TI-only click-out wording (CMS-1771). Kept separate from the shared
  // `buy_now` key, which Car Insurance also renders via ProductCard's staticText.
  ti_click_out: {
    _: 'Buy Now',
    zh: '官網投保',
  },
  copied: {
    _: 'Copied!',
    zh: '已複製!',
  },
  fetch_price: {
    _: 'Fetching live pricing',
    zh: '正在獲取即時價格',
  },
  off: {
    _: 'off',
    zh: '折扣',
  },
  policy_document: {
    _: 'Policy Document',
    zh: '保單文件',
  },
  plan_details: {
    _: 'Plan details',
    zh: '保險詳情',
  },
  promo_code: {
    _: 'Promo Code',
    zh: '指定邀請碼',
  },
  brand_take: {
    _: `SingSaver's take`,
  },
  calculateErrorPlaceholderMessage: {
    _: 'Check Provider',
    zh: '稍後查看',
  },
  coverage: {
    _: 'Coverage',
    zh: '保障',
  },
  drive_protected: {
    _: 'Drive Protected',
    zh: '安心駕駛',
  },
  eligibility: {
    _: 'Eligibility',
    zh: '申請資格',
  },
  fees: {
    _: 'Fees',
    zh: '費用',
  },
  key_features: {
    _: 'Key Features',
    zh: '主要特點',
  },
  premium: {
    _: 'Premium',
    zh: '保費',
  },
  repayment_details: {
    _: 'Repayment Details',
    zh: '還款詳情',
  },
  required_documents: {
    _: `Required Documents`,
    zh: `所需文件`,
  },
  steps_to_apply: {
    _: 'Steps to Apply',
    zh: '申請步驟',
  },
  up_to: {
    _: 'up to',
    zh: '高達',
  },
  update_amount_tenure: {
    _: 'Update Loan Amount / Tenure to Qualify',
    zh: '更新貸款金額/期限以符合條件',
  },
  amount_tenure_price_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> and loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts worth up to <b>:prefix:maxReward</b>.',
    zh: '請將您的貸款金額調整至至少 <b>:prefix:amount</b>，並將貸款期限更新至至少 <b>:tenure 個月</b>，以解鎖最高可獲得 <b>:prefix:maxReward</b> 的獨家禮品。',
  },
  amount_tenure_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> and loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts.',
    zh: '請將您的貸款金額調整至至少 <b>:prefix:amount</b>，並將貸款期限更新至至少 <b>:tenure 個月</b>，以解鎖獨家禮品。',
  },
  amount_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> to unlock exclusive gifts',
    zh: '請將您的貸款金額調整至至少 <b>:prefix:amount</b>，以解鎖獨家禮品。',
  },
  tenure_unlock_reward: {
    _: 'Update your loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts',
    zh: '請將您的貸款期限更新至至少 <b>:prefix:amount</b>，以解鎖獨家禮品。',
  },
  with_others: {
    _: 'with others only',
  },
  worth_up_reward: {
    _: '<b>worth up to :prefix:reward</b>',
  },

  bank_gift_info: {
    _: `You’ll also receive the following welcome gift(s) directly from the bank`,
    zh: `金融機構亦會賞你以下迎新優惠`,
  },
  brand_reward: {
    _: 'SingSaver Reward',
    zh: 'SingSaver獨家獎賞',
  },
  full_reward: {
    _: 'See the full reward and offer details',
    zh: '查看所有獎賞及優惠詳情',
  },
  loan_amount_exclusive: {
    _: `For a :product of :currency:amount over :tenure months, you’ll enjoy via :brand`,
    zh: `以 :product 申請 :currency:amount，分 :tenure 個月攤還，你將享有以下由 :brand 提供的優惠`,
  },
  provider_gift_info: {
    _: `You'll also receive the following welcome gift(s) directly from the provider`,
    zh: `金融機構亦會賞你以下迎新優惠`,
  },

  own_damage: {
    _: 'Own Damage/Theft',
  },

  act_nature: {
    _: 'Acts of Nature',
  },
  bodily_injury: {
    _: 'Bodily Injury',
  },
  property_damage: {
    _: 'Property Damage',
  },
  personal_accident: {
    _: 'Personal Accident',
  },
  doc_stamps: {
    _: 'Doc. Stamps (DST)',
  },
  local_gov: {
    _: 'Local Gov. (LGT)',
  },
  vat: {
    _: 'VAT',
  },
  type: {
    _: 'Type',
  },
  price: {
    _: 'Price',
  },
  net_premium: {
    _: 'Net Premium',
  },
  tax: {
    _: 'Tax',
  },
  tax_rate: {
    _: 'Tax Rate',
  },
  taxes_total: {
    _: 'Gross Premium',
  },
  approx_indicative_price: {
    _: 'Approx. <u>indicative price</u> after discounts',
    zh: '折扣後的約略參考價格',
  },
  approx_price: {
    _: 'Approx. price after discounts',
    zh: '折扣後的約略價格',
  },
  check_price: {
    _: 'Check Final Price',
    zh: '檢查最終價格',
  },
  live_pricing: {
    _: 'Live-pricing',
    zh: '即時報價',
  },
  starting_at: {
    _: 'Starting at',
    zh: '起價為',
  },
  // Must stay a fixed statement about the reference quote the base price comes
  // from - see BASE_PRICE_REFERENCE_PROFILE in SectionCarInsurance (INS-6583).
  static_pricing_default_tooltip: {
    _: 'Based on a 35 year old married male driving a 2021 Honda Vezel 1.5 with 50% NCD, a clean driving record, 10 years of driving experience with 0 claims in the last 3 years.',
  },
  live_pricing_default_tooltip: {
    _: "The prices shown are estimates and may change. For the most accurate pricing, please click Buy Now to check the insurance provider's website.",
  },
  brand_reward_guidance: {
    _: 'Singsaver Reward',
    zh: 'MoneyHero 獨家獎勵',
  },
  refresh: {
    _: 'Refresh',
    zh: '更新',
  },
  chat_for_quote: {
    _: 'Chat for Quote',
  },
  // Add mnemonics here
};

const ComparisonTableTranslations = staticText(baseTranslations);

export const TRANSLATIONS = brandSpecificStaticText({
  _: ComparisonTableTranslations,
  moneyhero: moneyHeroTranslation,
  money101: money101Translation,
  moneymax: moneyMaxTranslation,
});

const CONTENT_MHG = localeSpecificGroup(baseTranslations);

export type ProductCardTranslations = typeof TRANSLATIONS;
export type TranslationKey = keyof ReturnType<(typeof CONTENT_MHG)['get']>;
export type StaticText = ReturnType<(typeof CONTENT_MHG)['get']>;
